import { memo, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import allActions from '../../redux/actions/user'
import { types_act, timeFormat } from './utils'

import SearchIcon from '@material-ui/icons/Search'
import { TextField, Card, Select, FormControl, InputLabel, MenuItem } from '@mui/material'
import ModalCreneau from './ModalCreneau'
import BackButton from './BackButton'
import VirtualizedList from '../../components/VirtualizedList'
import CustomChip from '../../components/CustomChip'

const TENNIS = '7F8D84B4-C9F5-40E4-B8B3-FE69CB2B3803'
const EMPTY_CODE_ACT = '0'

export default memo(({ classes, typeRecherche, selectedCentre, selectedActivite, selectedAbonne, setSelectedAbonne, setStep, setSelectedCentre, setStepContents, setSelectedCrenaux, setSelectedActivite, goBack, filter, setFilter, filterTypeAct, setFilterTypeAct, family, categories, filterCatAct, setFilterCatAct }) => {
  
  const [activityModal, setActivityModal] = useState(false)
  const [items, setItems] = useState([])
  const [filteredItems, setFilteredItems] = useState([])

  const dispatch = useDispatch()

  const state = useSelector(state => state)
  const token = state.accessToken !== 'undefined' ? state.accessToken : ''

  const [filtersAbo, setFiltersAbo] = useState({
    adulte: true,
    ado: true,
    enfant: true,
  })

  useEffect(async () => {

    let url = 'api/new-souscription/list-centers-or-activities/'
    if(typeRecherche == 0) url += `centers/${selectedCentre.CNT_ID}`
    else url += `activities/${selectedActivite.ACT_ID}`

    
    const { json, err } = await allActions.fetchGetAPI(url, dispatch, token)
  
    //Si la requête n'a pas fonctionnné une erreur est affiché
    if (err) {
      return enqueueSnackbar('Erreur: ' + result.err, { variant: `error` })
    }
  
    //Si le serveur retourne une erreur elle est affiché
    if (json.err) {
      return enqueueSnackbar('Erreur: ' + result.json.err, { variant: `error` })
    }

    setItems(json.data)
    setFilteredItems(json.data)
    
  }, [])

  useEffect(() => {
    let new_filter

    if(typeRecherche == 1) {
      new_filter = items.filter(c => c.CNT_LIBELLE.toLowerCase().includes(filter.toLowerCase()))
    } else {  
      new_filter = items.filter(a => {
        if(!a.ACT_LIBELLE.toLowerCase().includes(filter.toLowerCase()) && filter !== '') return false
        if(filterTypeAct.id !== a.ACT_TA_ID && filterTypeAct.id !== 0) return false
        if(filterCatAct !== a.ACT_CODEACT_ID && filterCatAct !== EMPTY_CODE_ACT) return false
        if(!typeAboMatching(a)) return false
        return true
      })
    }
    
    setFilteredItems(new_filter)
  }, [filter, filterTypeAct, filterCatAct, filtersAbo])



  function toggleFilterTypeAbo(tybeAbo) {
    let newFiltersAbo = { ... filtersAbo }
    newFiltersAbo[tybeAbo] = !newFiltersAbo[tybeAbo]
    setFiltersAbo(newFiltersAbo)
  }

  function typeAboMatching(a) {
    if(a.TYPE_ABO.includes('adulte') && filtersAbo.adulte) return true
    if(a.TYPE_ABO.includes('ado') && filtersAbo.ado) return true
    if(a.TYPE_ABO.includes('enfant') && filtersAbo.enfant) return true
    return false
  }

  
  return (
    <>
      <ModalCreneau
        open={activityModal}
        classes={classes}
        close={() => setActivityModal(false)}
        setSelectedCrenaux={setSelectedCrenaux}
        setStepContents={setStepContents}
        setStep={setStep}
        typeRecherche={typeRecherche}
        selectedActivite={selectedActivite}
        selectedCentre={selectedCentre}
        selectedAbonne={selectedAbonne}
        setSelectedAbonne={setSelectedAbonne}
        family={family}
        timeFormat={timeFormat}
      />
      <div>
        <div className={classes.filters}>
          <div className={`${classes.field} ${typeRecherche === 1 ? 'full' : ''}`} >
            <SearchIcon />
            <TextField label="Recherche" size="small" fullWidth value={filter} onChange={(e) => setFilter(e.target.value)} />
          </div>
          {typeRecherche === 0 && (
            <div>
              <FormControl size="small" fullWidth >
                <InputLabel id="cat-label">Code</InputLabel>
                {categories.length && <Select
                  labelId="cat-label"
                  label="Code"
                  value={filterCatAct}
                  onChange={(e) => setFilterCatAct(e.target.value)}
                >
                  {categories.map((c) => <MenuItem key={c.CODEACT_ID} value={c.CODEACT_ID}>{c.CODEACT_LIBELLE}</MenuItem>)}
                </Select>}
              </FormControl>
              <FormControl size="small" fullWidth >
                <InputLabel id="act-label">Type d'activité</InputLabel>
                <Select
                  labelId="act-label"
                  label="Type d'activité"
                  value={filterTypeAct}
                  onChange={(event) => setFilterTypeAct(event.target.value)}
                >
                  {types_act.map(c => <MenuItem key={c.id} value={c}>{c.libelle}</MenuItem>)}
                </Select>
              </FormControl>
            </div>
          )}
        </div>

        {typeRecherche === 0 && (
          <div className={classes.filters2}>
            <CustomChip enabled={filtersAbo.enfant} onClick={() => toggleFilterTypeAbo('enfant')} label="Enfant"/>
            <CustomChip enabled={filtersAbo.ado} onClick={() => toggleFilterTypeAbo('ado')} label="Ado"/>
            <CustomChip enabled={filtersAbo.adulte} onClick={() => toggleFilterTypeAbo('adulte')} label="Adulte"/>
          </div>
        )}
      </div>
      
        
      <Card variant="outlined" className={classes.lists}>
        <VirtualizedList 
          items={filteredItems}
          selectedItem={(typeRecherche === 0 ? selectedActivite : selectedCentre)}
          keyLibelle={typeRecherche === 0 ? 'ACT_LIBELLE' : 'CNT_LIBELLE'}
          onItemClick={(item) => {
            if(typeRecherche == 0) setSelectedActivite(item)
            else setSelectedCentre(item)

            const act = (typeRecherche == 0) ? item : selectedActivite
            // If tennis Liberté
            if(act.ACT_ID === TENNIS) {
              setStep(2)
            } else {
              setActivityModal(true)
            }

            setStepContents(previous => {
              const newStepContents = [...previous]
              newStepContents[1] = typeRecherche == 0 ? item.ACT_LIBELLE : item.CNT_LIBELLE
              return newStepContents
            })
          }}
        />
      </Card>
      
      <BackButton back={goBack}/>
    </>
  )
})